import React, { useState, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";
import CorpNetApp from "./CorpNetApp";
import 'index.css';
const queryClient = new QueryClient();

function App() {
  const [page, setPage] = useState("home");

  // Scroll to top when page changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [page]);

  // For standalone development, show navbar and footer
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <CorpNetApp 
          page={page} 
          showNavbar={true} 
          showFooter={true} 
          onNavigate={(newPage) => setPage(newPage)}
        />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
